import { getComplianceCookies } from '@msc-b2c/shared-utils';
import type { MscKeyConfig, StorageComplianceKeyConfig } from './types';
import { STORAGE_TYPES } from './types';

let configCache: StorageComplianceKeyConfig | null = null;

function normalizeStorage(storage: string): string {
  if (storage === 'cookie') return STORAGE_TYPES.COOKIES;
  return storage || STORAGE_TYPES.LOCAL;
}

function normalizeConfig(raw: unknown[]): StorageComplianceKeyConfig {
  return raw.map((value: unknown) => {
    const item = value as Record<string, unknown>;
    return {
      key: (item['key'] as string) ?? '',
      pattern: (item['pattern'] as string) ?? (item['key'] as string) ?? '',
      category: (item['category'] as string) ?? '',
      storage: normalizeStorage((item['storage'] as string) ?? 'local'),
      ttlDays: (item['ttlDays'] as number) ?? 0,
      vendors: Array.isArray(item['vendors']) ? (item['vendors'] as string[]) : [],
      isPrefix: (item['isPrefix'] as boolean) ?? false,
    };
  }) as StorageComplianceKeyConfig;
}

function loadConfig(): StorageComplianceKeyConfig {
  if (configCache !== null && configCache.length > 0) return configCache;

  try {
    const raw = getComplianceCookies();
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    configCache = Array.isArray(parsed) ? normalizeConfig(parsed) : [];
  } catch {
    configCache = [];
  }

  return configCache;
}

export const getAllConfigs = (): StorageComplianceKeyConfig => loadConfig();

export function getPrefixConfigs(): StorageComplianceKeyConfig {
  return loadConfig().filter((item) => item.isPrefix);
}

export function getKeyConfig(key: string): MscKeyConfig | null {
  return loadConfig().find((item) => item.key === key) ?? null;
}

export function findPrefixConfig(key: string): MscKeyConfig | null {
  const prefixConfigs = getPrefixConfigs();
  for (const cfg of prefixConfigs) {
    try {
      if (new RegExp(cfg.pattern).test(key)) return cfg;
    } catch {
      console.log('error finding prefix config', key, cfg.pattern);
    }
  }
  return null;
}

export function __resetConfigCache(): void {
  configCache = null;
}
